import { defineStore } from "pinia";

export const useCountriesStore = defineStore("countries", {
  state: () => {
    return {
      countries: [],
    };
  },
  actions: {
    setCountries(countries) {
      this.countries = countries;
    },
  },
});
